import React, { Component } from 'react';
import GetTimer from './getTimer';

class getCuentas extends Component {
  constructor(){
    super();
    this.state = {
        cuentas: [],
        loading : false
    }
  }
  actualizar_cuentas = () =>{
    const url= this.props.url_proxyurl + this.props.url_global;

    fetch(url + 'webservices/getcuentas')
    .then(res => res.json())
    .then((data) => {
      this.setState({ cuentas: data, loading:false })
    })
    .catch(console.log)
    this.setState({
      loading:true
    })
  }
  componentDidMount() {
    this.actualizar_cuentas();
    this.props.getEncerarAPI(this.props.nombre_maquina);
  }

  render(){
      let loading;
      if(this.state.loading){
        loading =<div id="loader" className="loader loader-default is-active" data-text=""></div>
      }
      return (
        <React.Fragment>
        {loading}
        <GetTimer actualizar_cuentas={this.actualizar_cuentas} />
          {this.state.cuentas.map(cuenta_p =>
              <div key={cuenta_p.id_cuenta} className="css_item_cuenta">
                <button  className={cuenta_p.clase} onClick={ () => this.props.Abtn_abrir_cuenta(cuenta_p.id_cuenta,cuenta_p.cuenta,cuenta_p.id_tipo_cuenta,cuenta_p.clase)}>
                {cuenta_p.cuenta}
                </button>
              </div>
            )
          }
        </React.Fragment>
      )
  }
}

export default getCuentas;
